import { Button, Container, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { localePath } from '#marketing/lib/marketing-locale.js';
import { useMarketingLocale } from '#marketing/lib/use-marketing-locale.js';
import { MarketingSection } from './MarketingSection.jsx';

/**
 * Public /about page.
 */
export function MarketingAboutPage() {
  const { t } = useTranslation('common');
  const locale = useMarketingLocale();
  return (
    <Container size="md" py="xl">
      <MarketingSection
        titleKey="marketing.about.heroTitle"
        descriptionKey="marketing.about.heroDescription"
      />

      <Stack gap="xl" mb="xl">
        <section>
          <Title order={2} size="h3" mb="sm">
            {t('marketing.about.problemTitle')}
          </Title>
          <Text>{t('marketing.about.problemBody')}</Text>
        </section>

        <section>
          <Title order={2} size="h3" mb="sm">
            {t('marketing.about.solutionTitle')}
          </Title>
          <Text>{t('marketing.about.solutionBody')}</Text>
          <Text mt="sm">{t('marketing.about.solutionPrinciples')}</Text>
          <Text mt="sm">{t('marketing.about.solutionTagline')}</Text>
        </section>

        <section>
          <Title order={2} size="h3" mb="sm">
            {t('marketing.about.founderTitle')}
          </Title>
          <Text>{t('marketing.about.founderBody')}</Text>
        </section>
      </Stack>

      <Paper withBorder radius="md" p="xl" bg="pachubColourScheme.0" ta="center">
        <Text fw={700} size="lg" mb="sm">
          {t('marketing.about.ctaTitle')}
        </Text>
        <Text c="dimmed" mb="lg">
          {t('marketing.about.ctaDescription')}
        </Text>
        <Group justify="center">
          <Button component={Link} to={localePath(locale, '/contact')} color="pachubColourScheme">
            {t('marketing.about.ctaButton')}
          </Button>
        </Group>
      </Paper>
    </Container>
  );
}
